import React, { useState } from 'react';

const StudentFormFields = ({ fields, onChange }) => {
  const [values, setValues] = useState({});

  const handleChange = (field_id, value) => {
    const updated = { ...values, [field_id]: value };
    setValues(updated);

    // Send array to parent
    const arr = Object.entries(updated).map(([id, val]) => ({
      field_id: parseInt(id),
      field_value: val,
    }));
    onChange(arr);
  };

  return (
    <div className="dynamic-fields">
      {fields.map((field) => (
        <div key={field.id} className="form-group">

          <label>
            {field.field_name}
            {field.is_required === 1
              ? <span className="req"> *</span>
              : <span className="opt"> (optional)</span>
            }
          </label>

          {/* DROPDOWN */}
          {field.field_type === 'dropdown' && (
            <select
              className="form-control"
              required={field.is_required === 1}
              defaultValue=""
              onChange={(e) => handleChange(field.id, e.target.value)}
            >
              <option value="" disabled>
                -- Select {field.field_name} --
              </option>
              {Array.isArray(field.options) 
                ? field.options.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))
                : field.options?.split(',').map((opt) => (
                    <option key={opt.trim()} value={opt.trim()}>
                      {opt.trim()}
                    </option>
                  ))
              }
            </select>
          )}

          {/* DATE */}
          {field.field_type === 'date' && (
            <input
              type="date"
              className="form-control"
              required={field.is_required === 1}
              onChange={(e) => handleChange(field.id, e.target.value)}
            />
          )}

          {/* NUMBER */}
          {field.field_type === 'number' && (
            <input
              type="number"
              className="form-control"
              placeholder={`Enter ${field.field_name}`}
              required={field.is_required === 1}
              onChange={(e) => handleChange(field.id, e.target.value)}
            />
          )}

          {/* TEXT (default) */}
          {(field.field_type === 'text' || !field.field_type) && (
            <input
              type="text"
              className="form-control"
              placeholder={`Enter ${field.field_name}`}
              required={field.is_required === 1}
              onChange={(e) => handleChange(field.id, e.target.value)}
            />
          )}

        </div>
      ))}
    </div>
  );
};

export default StudentFormFields;
